import { inject, Injectable } from '@angular/core'
import { Actions, ofType } from '@ngrx/effects'
import { pluck } from 'rxjs/operators'

import * as fromProfile from '.'

@Injectable()
export class ProfileEffects {
  private readonly actions$ = inject(Actions)

  readonly hide$ = this.actions$.pipe(ofType(fromProfile.Actions.hide), pluck('id'))
}
